import { render, staticRenderFns } from "./ProfilePersonal.vue?vue&type=template&id=6e42a23b&scoped=true&"
import script from "./ProfilePersonal.vue?vue&type=script&lang=js&"
export * from "./ProfilePersonal.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePersonal.vue?vue&type=style&index=0&id=6e42a23b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e42a23b",
  null
  
)

export default component.exports